import { filterTypes } from 'hse-filtering-library-frontend';
import { push } from 'connected-react-router';
import { takePut, takeQuery } from 'react-lib/dist/agent-es';
import {
  getSearchQuery,
  getExcelParams,
} from 'hse-filtering-library-frontend/src/QueryGenerators/JavaQueryBuilder';
import { getSearchQuery as selectSearchQuery } from 'hse-filtering-library-frontend/src/Behavior/selectors';
import overrideExelParams from '../../../utils/overrideExelParams';
import goToErrorPage from '../../../utils/goToErrorPage';
import { api } from '../../../agent';

const FilterApi = {
  getColumnsAndFields: ({ entityType }) =>
    api.get(`/filteringCustom/{entityType}/getColumnsAndFields`, { entityType }),
  getAggregatingDefaultState: ({ entityType }) => api.get(`/aggregate/${entityType}/initiateState`),
  getAutoCompleteSuggestions: ({ entityType, inputName, inputValue }) =>
    api.get(
      `/filtering/{entityType}/autoCompleteSuggestions`,
      { entityType },
      { inputName, inputValue }
    ),
  applyFilter: ({ entityType, ...rest }) =>
    api.post(`/filteringCustom/${entityType}/filter`, {
      ...getSearchQuery({
        entityType,
        ...rest,
      }),
    }),
  getRecordDetails: ({ entityType, id, lang }) =>
    api.get(
      `/filteringCustom/{entityType}/recordDetails`,
      { entityType },
      {
        id,
        lang: lang.toUpperCase(),
      }
    ),
  getFavoriteList: ({ entityType, personId }) =>
    api.get('/favorites/{entityType}/list', { entityType }, { personId }),
  saveFavorite: ({ entityType, body }) => api.post(`/favorites/${entityType}/save`, body),
  deleteFavorite: ({ entityType, id }) =>
    api.get(`/favorites/{entityType}/deleteReport`, { entityType }, { id }),
  getFavorite: ({ entityType, id }) =>
    api.get(`/favorites/{entityType}/getReport`, { entityType }, { id }),
  getExcel: ({
    entityType,
    filters,
    sort,
    possibleFieldsList,
    backgroundFiltersList,
    visibleColumns,
    possibleColumnsList,
    filterValues,
    lang,
  }) => {
    let excelParams = getExcelParams({
      filters,
      sort,
      possibleFieldsList,
      backgroundFiltersList,
      visibleColumns,
      possibleColumnsList,
      filterValues,
      lang,
    });
    excelParams = overrideExelParams(excelParams);
    return api.csv('/{entityType}/excel', { entityType }, undefined, 'post', excelParams);
  },
};

export default [
  takeQuery(filterTypes.GET_COLUMNS_AND_FIELDS, FilterApi.getColumnsAndFields),
  takeQuery(filterTypes.GET_AGGREGATING_DEFAULT_STATE, FilterApi.getAggregatingDefaultState),
  takeQuery(filterTypes.GET_AUTO_COMPLETE_SUGGESTIONS, FilterApi.getAutoCompleteSuggestions),
  takeQuery(filterTypes.GET_RECORD_DETAILS, FilterApi.getRecordDetails),
  takeQuery(filterTypes.GET_FAVORITE_LIST, FilterApi.getFavoriteList),
  takeQuery(filterTypes.SAVE_FAVORITE, {
    api: FilterApi.saveFavorite,
    notify: [({ data: favoriteId }) => push({ search: `?favoriteId=${favoriteId}` })],
  }),
  takeQuery(filterTypes.DELETE_FAVORITE, FilterApi.deleteFavorite),
  takeQuery(filterTypes.GET_FAVORITE, FilterApi.getFavorite),
  takeQuery(filterTypes.GET_EXCEL, FilterApi.getExcel),
  takePut(filterTypes.INITIALIZE_FILTERING, [
    filterTypes.GET_COLUMNS_AND_FIELDS,
    filterTypes.GET_AGGREGATING_DEFAULT_STATE,
  ]),
  takePut(filterTypes.APPLY_FILTERS, [filterTypes.APPLY_FILTER]),
  takeQuery(filterTypes.APPLY_FILTER, {
    api: FilterApi.applyFilter,
    select: selectSearchQuery,
    notifyFailure: [response => goToErrorPage(response.response)],
  }),
];
